import styled from 'styled-components';

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  word-break: break-word;
  white-space: nowrap;
`;
